 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTMLCOVER from '@/components/xhtml/cover'
 import XHTMLCONT from '@/components/xhtml/cont'
 import XHTMLDEDICATION from '@/components/xhtml/dedication'
 import XHTMLMAP from '@/components/xhtml/map'
 import XHTMLCH01 from '@/components/xhtml/ch01'
 import XHTMLCH01A from '@/components/xhtml/ch01a'
 import XHTMLCH01B from '@/components/xhtml/ch01b'
 import XHTMLCH02 from '@/components/xhtml/ch02'
 import XHTMLCH02A from '@/components/xhtml/ch02a'
 import XHTMLCH02B from '@/components/xhtml/ch02b'
 import XHTMLCH03 from '@/components/xhtml/ch03'
 import XHTMLCH03A from '@/components/xhtml/ch03a'
 import XHTMLCH04 from '@/components/xhtml/ch04'
 import XHTMLCH05 from '@/components/xhtml/ch05'
 import XHTMLCH05A from '@/components/xhtml/ch05a'
 import XHTMLCH05B from '@/components/xhtml/ch05b'
 import XHTMLCH06 from '@/components/xhtml/ch06'
 import XHTMLCH06A from '@/components/xhtml/ch06a'
 import XHTMLCH06B from '@/components/xhtml/ch06b'
 import XHTMLCH07 from '@/components/xhtml/ch07'
 import XHTMLCH07A from '@/components/xhtml/ch07a'
 import XHTMLCH07B from '@/components/xhtml/ch07b'
 import XHTMLCH08 from '@/components/xhtml/ch08'
 import XHTMLCH08A from '@/components/xhtml/ch08a'
 import XHTMLCH08B from '@/components/xhtml/ch08b'
 import XHTMLCH09 from '@/components/xhtml/ch09'
 import XHTMLCH10 from '@/components/xhtml/ch10'
 import XHTMLCH10A from '@/components/xhtml/ch10a'
 import XHTMLCH10B from '@/components/xhtml/ch10b'
 import XHTMLTREASURE from '@/components/xhtml/treasure'
 import XHTMLAUTHORBIO from '@/components/xhtml/authorbio'
 import XHTMLALSO from '@/components/xhtml/also'
 import XHTMLBACK from '@/components/xhtml/back'
 import XHTMLCOPYRIGHT from '@/components/xhtml/copyright'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/cont",
 			"name" : "xhtml/cont",
 			"component" : XHTMLCONT
 		},
 		{
 			"path" : "/xhtml/dedication",
 			"name" : "xhtml/dedication",
 			"component" : XHTMLDEDICATION
 		},
 		{
 			"path" : "/xhtml/map",
 			"name" : "xhtml/map",
 			"component" : XHTMLMAP
 		},
 		{
 			"path" : "/xhtml/ch01",
 			"name" : "xhtml/ch01",
 			"component" : XHTMLCH01
 		},
 		{
 			"path" : "/xhtml/ch01a",
 			"name" : "xhtml/ch01a",
 			"component" : XHTMLCH01A
 		},
 		{
 			"path" : "/xhtml/ch01b",
 			"name" : "xhtml/ch01b",
 			"component" : XHTMLCH01B
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js